import { render } from "./Somos.vue?vue&type=template&id=2104374a"
import script from "./Somos.vue?vue&type=script&lang=js"
export * from "./Somos.vue?vue&type=script&lang=js"

import "./Somos.vue?vue&type=style&index=0&id=2104374a&lang=css"
script.render = render

export default script